// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__VsJ0l","search":"Settings_search__2ct1N","filter":"Settings_filter__3Wuwp"};